import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Link} from '../../common/components';
import {Icon} from '../../common/components/Icon';


// NB - this TOC component is used for both the sidebar TOC and the navbar TOC
export class TOC extends Component<jsx.Props, jsx.State> {
    renderSubsections(section) {
        if (section.listItems && this.props.type === 'sidebar') {
            return (
                <ul className="toc-subsection">
                    {section.listItems.map( (subsection) => {
                        return (
                            <li className="toc-subheading">
                                <Link to={`#${section.id}-${subsection.id}`} className={this.props.hash.split('-')[1] === subsection.id ? 'open selected' : ''}>
                                    {subsection.label}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            );
        } else {
            return '';
        }
    }

    render() {
        const pageLabelPrefix = (this.props.pageLabelPrefix ? this.props.pageLabelPrefix : 'api-other');

        const tocSections = this.props.tocSections.map( (section) => {
            const selected = this.props.hash.split('-')[0] === section.id;
            return (
                <li className={'toc-section'}>
                    <Link to={`#${section.id}`} className={ selected ? 'open selected' : 'closed' }>
                        <img src={selected ? `${section.icon.split('.svg')[0]}-blue.svg` : section.icon} width="14" height="14"/>
                        {section.label}
                    </Link>
                    {this.renderSubsections(section)}
                </li>
            );
        });

        if (pageLabelPrefix === 'api-docs') {
            tocSections.push(
                <li className="toc-section separator">
                    <Link to={'/gifapi'} clickLabel={`${pageLabelPrefix}-learn-more-homepage`}>
                        <div>
                            <span className="spacer"/>
                            <span>Learn More</span>
                        </div>
                        <Icon name="chevron-right" style={{'color': '#4A4A4A', 'font-size': '10px'}}/>
                    </Link>
                </li>);
        }

        if (this.props.type === 'navbar') {
            tocSections.push(
                <li className="toc-section separator">
                    <Link
                        to={'/developer/dashboard'}
                        clickLabel={`${pageLabelPrefix}-developer-dashboard`}
                    >
                        <div>
                            <img src={'/assets/img/api/login.svg'} width="14" height="14"/>
                            <span>Developer Log In</span>
                        </div>
                        <Icon name="chevron-right" style={{'color': '#4A4A4A', 'font-size': '10px'}}/>
                    </Link>
                </li>);
        }

        return (
            <div id={`toc-${this.props.type}`}>
                {tocSections}
            </div>
        );
    }
}
